import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-634fce52"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "main-div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lblTitle" }, "Terms of Service", -1 /* HOISTED */))
const _hoisted_4 = { class: "back-div" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    _createVNode($setup["SalesNoteHeaderNavigation"]),
    _createVNode($setup["SalesNoteLinkNavigation"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary text-center btn-back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goBack()))
        }, "Back")
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.kdpSalesNoteScreenFlg == 'Confirm']
      ]),
      _createElementVNode("div", {
        class: "tosInfo",
        onScroll: $setup.scrollevent,
        style: _normalizeStyle({'--tosInfoHeight': $setup.tofInfoHeight })
      }, [
        ($setup.showFlg == 1)
          ? (_openBlock(), _createBlock($setup["TermsofServiceInfo1"], { key: 0 }))
          : (_openBlock(), _createBlock($setup["TermsofServiceInfo2"], { key: 1 }))
      ], 36 /* STYLE, HYDRATE_EVENTS */),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary text-center btn-next",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goNext())),
          disabled: $setup.btnNext
        }, "Next", 8 /* PROPS */, _hoisted_5)
      ])
    ])
  ]))
}